<template>
  <transition name="fade">
    <div class="times">
      <Button
        v-for="(booking, id) in $store.state.availableBookings"
        :key="booking.date"
        link="#form"
        :text="getLabel(booking.label)"
        @click="$store.commit('setSelectedBooking', booking.date)"
        :class="[ booking.date === $store.state.selectedBooking ? 'selected' : '', ...booking.classes ]"        
        :style="`transition-delay:${0 * 50}ms`"
      />
    </div>
  </transition>
</template>
<script>
import Button from "@/components/TimeButton";
export default {
  name: "AvailableTimes",
  components: {
    Button,
  },
  methods : {
    getLabel(label) {
      if(['booked', "past'"].includes(label.toLowerCase())) {
        return label;      
      } else {
        return `${label} CT`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.booked {
  pointer-events: none;
  opacity: 0.5;
  background: var(--dark-red);
  border:none;
  display:none !important;  
}
.times {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 30px;
  max-height: calc(max(305px, 35vh));
  @media (min-width:1160px) {
    max-height: 600px;
  }
  overflow: auto;
  min-width:200px;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--darker-blue);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--blue);
  }
}
</style>